import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Subject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

const THEME_KEY = 'EDASH_DARK_THEME'
@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  private darkTheme$ = new Subject<boolean>();
  private isDarkTheme: boolean;

  constructor(private cookie: CookieService, private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  get darkTheme() {
    return this.darkTheme$.asObservable();
  }

  setTheme(value: boolean) {
    this.darkTheme$.subscribe(
      (isDarkTheme) => {
        this.isDarkTheme = isDarkTheme
      }
    );
    this.darkTheme$.next(value);
    if (value) {
      this.setDarkTheme();
    }
  }

  toggleDarkTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    if (this.isDarkTheme) {
      this.setDarkTheme();
    } else {
      this.setLightTheme();
    }
    this.darkTheme$.next(this.isDarkTheme);
  }

  setDarkTheme() {
    this.cookie.set(THEME_KEY, 'true', undefined, undefined, undefined, true);      
    this.renderer.addClass(document.body, 'dark-theme');
  }

  setLightTheme() {
    this.cookie.delete(THEME_KEY);
    this.renderer.removeClass(document.body, 'dark-theme');
  }
}
